// Small client-side helper to fetch an invisible Turnstile token on demand
// Loads the Turnstile script once and executes an invisible widget

let turnstileScriptLoadingPromise: Promise<void> | null = null;

function loadTurnstileScript(): Promise<void> {
  if (turnstileScriptLoadingPromise) return turnstileScriptLoadingPromise;
  turnstileScriptLoadingPromise = new Promise<void>((resolve) => {
    const scriptId = 'turnstile-script';
    if (document.getElementById(scriptId)) {
      resolve();
      return;
    }
    const s = document.createElement('script');
    s.id = scriptId;
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    // Ensure resolve eventually even if onload doesn't fire
    setTimeout(() => resolve(), 1000);
    document.head.appendChild(s);
  });
  return turnstileScriptLoadingPromise;
}

export async function getInvisibleTurnstileToken(
  siteKey: string | null | undefined,
  featureEnabled: boolean
): Promise<string | null> {
  if (!featureEnabled || !siteKey) return null;

  await loadTurnstileScript();

  return await new Promise<string | null>((resolve) => {
    const container = document.createElement('div');
    container.style.display = 'none';
    document.body.appendChild(container);

    const waitForTurnstile = () => {
      const anyWindow = window as unknown as { turnstile?: any };
      if (!anyWindow.turnstile) { setTimeout(waitForTurnstile, 50); return; }
      try {
        const id = anyWindow.turnstile.render(container, {
          sitekey: siteKey,
          size: 'invisible',
          callback: (t: string) => {
            resolve(t);
            setTimeout(() => { try { anyWindow.turnstile?.remove(id); } catch {} }, 0);
          },
          'error-callback': () => resolve(null),
          'timeout-callback': () => resolve(null),
        });
        anyWindow.turnstile.execute(id);
      } catch {
        resolve(null);
      }
    };
    waitForTurnstile();
  });
}


